import { useSyncExternalStore } from "react";
import { readCoachConsoleDocumentIdsVisible } from "../utils/coachConsoleDocumentIds";

function subscribe(onChange) {
  if (typeof window === "undefined") return () => {};
  const handler = () => onChange();
  window.addEventListener("m45-coach-console-doc-ids-visibility", handler);
  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener("m45-coach-console-doc-ids-visibility", handler);
    window.removeEventListener("storage", handler);
  };
}

function getSnapshot() {
  return readCoachConsoleDocumentIdsVisible();
}

function getServerSnapshot() {
  return false;
}

/**
 * When true, show primary Firestore document IDs where the UI supports it (admin, protocol details, etc.).
 * Enable via: `?docIds=1` or `?debugIds=1`, `sessionStorage` / `localStorage` key `m45CoachConsoleShowDocIds=1`,
 * or triple-click the header logo (see MainHeader).
 */
export default function useCoachConsoleDocumentIdsVisible() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
